import { render, staticRenderFns } from "./create-preferential.vue?vue&type=template&id=0c9f66e0&scoped=true&"
import script from "./create-preferential.vue?vue&type=script&lang=ts&"
export * from "./create-preferential.vue?vue&type=script&lang=ts&"
import style0 from "./create-preferential.vue?vue&type=style&index=0&id=0c9f66e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c9f66e0",
  null
  
)

component.options.__file = "create-preferential.vue"
export default component.exports